import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { Table, Header } from 'semantic-ui-react';

import ListRow from './ListRow';

class OfferUpgradesList extends Component {
  render() {
    const { allFiles } = this.props;
    const listRow = ListRow();

    const headerRow = (
      <Table.Row>
        <Table.HeaderCell singleLine textAlign='center'>
          Input File
        </Table.HeaderCell>
        <Table.HeaderCell singleLine textAlign='center'>
          Output File{' '}
        </Table.HeaderCell>
        <Table.HeaderCell singleLine textAlign='center'>
          Status
        </Table.HeaderCell>
      </Table.Row>
    );

    return (
      <div>
        <div>
          <Header>Offer Upgrades</Header>
          <Table
            celled
            selectable
            padded
            renderBodyRow={listRow}
            tableData={allFiles}
            headerRow={headerRow}
            size='large'
            compact='very'
            style={{ fontSize: '90%' }}
            striped
          />
        </div>
      </div>
    );
  }
}

OfferUpgradesList.propTypes = {
  allFiles: PropTypes.array,
};

OfferUpgradesList.defaultProps = {
  allFiles: [],
};

export default OfferUpgradesList;
